import * as React from 'react';
import { cn } from '@/lib/utils';

export interface WfCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 'card' = section do wireframe (bg card, radius 12); 'surface' = .gc (bg surface, radius 8). */
  variant?: 'card' | 'surface';
}

/** Card base do wireframe (section / .gc). Burro: só aplica .wf-card[--surface]. */
export const WfCard = React.forwardRef<HTMLDivElement, WfCardProps>(
  ({ variant = 'card', className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('wf-card', variant === 'surface' && 'wf-card--surface', className)}
      {...props}
    >
      {children}
    </div>
  )
);
WfCard.displayName = 'WfCard';
